module.exports = __webpack_public_path__ + "static/media/vector1a.67da67e3.png";